import React, { useState } from 'react';
import {MuiGrid, MuiBox, MuiButton, MuiTypography, MuiInputField } from 'components/MUI';
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import { ArrowForwardIcon } from 'helpers/Icons';
import Theme from 'Theme';
import { required, whiteSpaceNotAllowedFirstLetter } from 'validators';

const appearance = {
    theme: 'stripe',
    variables: {
        colorPrimary: '#0570de',
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#df1b41',
        fontFamily: 'Ideal Sans, system-ui, sans-serif',
        spacingUnit: '2px',
        borderRadius: '4px',
    }
};

function CreditCard(props) {

    const { onSubmit, isTrial } = props;
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [paymentError, setPaymentError] = useState('');

    const stripe = useStripe();
    const elements = useElements(appearance);


    const handleCardClick = async () => {
        setNameError('');

        if (required(name) || whiteSpaceNotAllowedFirstLetter(name)){
            setNameError('Your name is required. The first letter cannot be a space');
            return
        }

        if (!stripe || !elements) {
            console.log('Stripe.js has not yet loaded.');
            return
        };
        const result = await stripe.createPaymentMethod({ type: 'card',
            card:elements.getElement(CardNumberElement),
            // billing_details: elements.getElement(AddressElement),
            billing_details: {
                name: name
            }
         });
        if (result.error) {
            setPaymentError(result.error.message);
            return
        }
        if (onSubmit) onSubmit({payment_method:result.paymentMethod.id});
    }


    return (
     
        <MuiBox>
            <MuiGrid container spacing={2}>
                <MuiGrid item xs={12} sx={{
                    '& .MuiFormControl-root': {
                        marginBottom: 0,
                        '& input': {
                            fontSize: 16,
                            '::placeholder': {
                                color: '#000',
                                opacity: 1,
                            }
                        }
                    }
                }}>
                    <MuiInputField
                        name='name'
                        onChange={e => setName(e.target.value)}
                        value={name}
                        placeholder='Name on card'
                        error={Boolean(nameError)}
                        helperText={nameError || ""}
                    />
                </MuiGrid>
                <MuiGrid item xs={12}>
                    <MuiBox className='stripeInputField'>
                        <CardNumberElement  />
                    </MuiBox>
                </MuiGrid>
                <MuiGrid item sm={6} xs={12}>
                    <MuiBox className='stripeInputField'>
                        <CardExpiryElement  />
                    </MuiBox>
                </MuiGrid>
                <MuiGrid item sm={6} xs={12}>
                    <MuiBox className='stripeInputField'>
                        <CardCvcElement  />
                    </MuiBox>
                </MuiGrid>
                {/* <MuiGrid item sm={6} xs={12}>
                    <MuiBox className='stripeInputField'>
                        <AddressElement  options={{mode: 'billing'}} />
                    </MuiBox>
                </MuiGrid> */}
                <MuiGrid item xs={12}>
                    {paymentError && <MuiTypography variant='body3' sx={{
                        color: Theme.palette.error.main
                    }}>{paymentError}</MuiTypography>}
                </MuiGrid>
                <MuiGrid item xs={12}>
                <MuiButton
                    onClick={handleCardClick}
                    width='full'
                    iconposition='right'
                    endIcon={<ArrowForwardIcon />}
                >
                    {isTrial ? 'Add Card & Pay' : 'Add Card'}
                </MuiButton>
                </MuiGrid>
            </MuiGrid>
        </MuiBox>
    )
}

export default CreditCard